// @react-compiler enable
import {testIdProps} from '@github-ui/test-id-props'
import {memo} from 'react'

import type {EnrichedText} from '../../../api/columns/contracts/text'
import {TableRowHeight} from '../../../api/view/contracts'
import {getTableRowHeightLineClamp} from '../../../helpers/table-row-height'
import {useTableRowHeight} from '../../../hooks/use-table-row-height'
import {type ColumnValue, isEmpty, isLoading} from '../../../models/column-value'
import type {MemexItemModel} from '../../../models/memex-item-model'
import {TextPlaceholder} from '../../common/placeholders'
import {BaseCell} from '../cells/base-cell'
import {TextCell} from '../cells/text-cell'
import {useRecordCellRenderer} from '../performance-measurements'

type Props = Readonly<{
  currentValue: ColumnValue<EnrichedText>
  model: MemexItemModel
  isDisabled?: boolean
}>

export const LoadingTextCell = () => (
  <BaseCell>
    <TextPlaceholder minWidth={80} maxWidth={200} {...testIdProps('placeholder')} />
  </BaseCell>
)

// eslint-disable-next-line @typescript-eslint/no-shadow -- match renderer memo naming convention for React DevTools.
export const TextRenderer = memo(function TextRenderer({currentValue, model, isDisabled}: Props) {
  useRecordCellRenderer('TextRenderer', model.id)
  const {rowHeight} = useTableRowHeight()
  const isWrapping = rowHeight !== TableRowHeight.Single
  const lineClamp = getTableRowHeightLineClamp(rowHeight)

  if (isLoading(currentValue)) {
    return <LoadingTextCell />
  }

  if (isEmpty(currentValue)) {
    return null
  }

  return (
    <BaseCell>
      <TextCell
        dangerousHtml={currentValue.value.html}
        isDisabled={isDisabled}
        isWrapping={isWrapping}
        lineClamp={lineClamp}
      />
    </BaseCell>
  )
})
